import { render } from "./v-productEdit.vue?vue&type=template&id=473e9c78"
import script from "./v-productEdit.vue?vue&type=script&lang=js"
export * from "./v-productEdit.vue?vue&type=script&lang=js"

import "./v-productEdit.vue?vue&type=style&index=0&id=473e9c78&lang=css"
script.render = render

export default script